import { styled } from '@mui/material/styles';
import { Card, Button } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.base.offWhite3,
  color: theme.palette.text.primary,
}));

export const ResponseText = styled('div')(({ theme }) => ({
  fontSize: theme.typography.heading.md,
}));

export const StatusLabel = styled('div')(({ theme }) => ({
  fontSize: theme.typography.heading.md,
  fontWeight: theme.typography.fontSemiBoldWeight,
  padding: theme.spacing(2, 0, 1),
}));

export const StyledInput = styled('input')({
  height: '35px',
});

export const StyledButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.base.black}`,
  '&:disabled': {
    opacity: 0.5,
    border: `1px solid ${theme.palette.base.gray}`,
  },
}));

export const BulkCourseContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 0),
}));
